import { CardAccountDetailsStarOutlineIcon } from './CardAccountDetailsStarOutlineIcon';

/**
 * author: Michael Richins
 * id 97C9CAC2-9F94-40EA-9A08-1A9BDD208743
 * name card-account-details-star-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-account-details-star-outline.svg
 * tags
 * - Account / User 
 */
export const CardAccountDetailsFavoriteOutlineIcon = CardAccountDetailsStarOutlineIcon;
export default CardAccountDetailsFavoriteOutlineIcon